import { ComponentProps } from "react"

import Preset1 from "@/assets/textures/preset-1.svg?react"
import Preset2 from "@/assets/textures/preset-2.svg?react"
import Preset3 from "@/assets/textures/preset-3.svg?react"
import Preset4 from "@/assets/textures/preset-4.svg?react"

import { cn } from "../lib"

const PRESET_GLOW_CLASS = {
  green: "shadow-[0_0_6px_1px_rgba(0,254,116,0.85)]",
  orange: "shadow-[0_0_6px_1px_rgba(252,210,85,0.85)]",
} as const

const PresetButton = ({
  presetNumber,
  variant = "default",
  className,
  children,
  ...props
}: ComponentProps<"button"> & {
  presetNumber: number
  variant?: "default" | "green" | "orange"
}) => {
  const CorrectPreset =
    presetNumber === 1
      ? Preset1
      : presetNumber === 2
        ? Preset2
        : presetNumber === 3
          ? Preset3
          : Preset4

  const isActive = variant !== "default"

  return (
    <button
      type="button"
      className={cn(
        "relative isolate flex h-11 w-full min-w-0 items-center justify-center",
        isActive && "z-10",
        className
      )}
      {...props}
    >
      {isActive ? (
        <span
          aria-hidden
          className={cn(
            "pointer-events-none absolute inset-0 rounded-[22px]",
            PRESET_GLOW_CLASS[variant]
          )}
        />
      ) : null}
      <CorrectPreset
        className={cn(
          "absolute inset-0 z-[1] h-full w-full",
          variant === "default" && "text-[#9594B3]",
          variant === "green" && "text-green-100",
          variant === "orange" && "text-[#FCD255]"
        )}
      />
      <span
        className={cn(
          "relative z-[2] text-base/none font-black text-white drop-shadow-[0px_1px_0px_rgb(0,0,0)] [text-shadow:_0.5px_0_0.5px_black,_-0.5px_0_0.5px_black,_0px_-0.5px_0.5px_black]",
          variant === "green" && "text-green-100",
          variant === "orange" && "text-[#FCD255]"
        )}
      >
        {children}
      </span>
    </button>
  )
}

export default PresetButton
